import { render, staticRenderFns } from "./show-tab.vue?vue&type=template&id=9461978c&"
import script from "./show-tab.vue?vue&type=script&lang=js&"
export * from "./show-tab.vue?vue&type=script&lang=js&"
import style0 from "./show-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports